import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NotificationsState, Notification } from './notificationsTypes';
import { notificationsAPI } from './notificationsAPI';

const initialState: NotificationsState = {
  notifications: [],
  unreadCount: 0,
  preferences: null,
  loading: false,
  error: null,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notification>) => {
      state.notifications.unshift(action.payload);
      if (!action.payload.read) {
        state.unreadCount += 1;
      }
    },
    clearNotificationsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Get Notifications
    builder.addMatcher(
      notificationsAPI.endpoints.getNotifications.matchPending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    );
    builder.addMatcher(
      notificationsAPI.endpoints.getNotifications.matchFulfilled,
      (state, action) => {
        state.loading = false;
        state.notifications = action.payload;
      }
    );
    builder.addMatcher(
      notificationsAPI.endpoints.getNotifications.matchRejected,
      (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message || 'Failed to fetch notifications';
      }
    );
    
    // Get Unread Count
    builder.addMatcher(
      notificationsAPI.endpoints.getUnreadCount.matchFulfilled,
      (state, action) => {
        state.unreadCount = action.payload.count;
      }
    );
    
    // Get Preferences
    builder.addMatcher(
      notificationsAPI.endpoints.getNotificationPreferences.matchFulfilled,
      (state, action) => {
        state.preferences = action.payload;
      }
    );
    
    // Mark as Read
    builder.addMatcher(
      notificationsAPI.endpoints.markAsRead.matchFulfilled,
      (state) => {
        if (state.unreadCount > 0) {
          state.unreadCount -= 1;
        }
      }
    );
    
    // Mark All as Read
    builder.addMatcher(
      notificationsAPI.endpoints.markAllAsRead.matchFulfilled,
      (state) => {
        state.unreadCount = 0;
        state.notifications = state.notifications.map(n => ({ ...n, read: true }));
      }
    );
  },
});

export const { addNotification, clearNotificationsError } = notificationsSlice.actions;
export default notificationsSlice.reducer;
